// @ts-check
import { observer } from 'mobx-react-lite';
import React from 'react';
import { toLocalCurrency } from '../../../utils/currency';
import { getLocationInfo } from '../../../utils/location';
import { usePromise } from '../../_shared/react-hooks';

const COUNTRIES_WITH_AFTERPAY = ['US'];

let AfterPay = ({ price: actualPrice, shouldShowPrice = false }: { price: number; shouldShowPrice?: boolean }) => {
  const { data: locationInfo } = usePromise(getLocationInfo);
  const supportsAfterPay = COUNTRIES_WITH_AFTERPAY.includes(locationInfo?.country_code ?? '');

  const installment = actualPrice / 4;

  const modalToggle = (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a className="afterpay__modal-toggle" data-toggle="modal" data-target="#AfterPay" role="button">
      <span className="alo-afterpay-logo-icon"></span>
      <span className="alo-info-icon"></span>
    </a>
  );
  return (
    <div className="afterpay__wrapper">
      {supportsAfterPay ? (
        <>
          {actualPrice >= 10 ? (
            <p className="afterpay__p body-small">
              {`${shouldShowPrice ? '$' + actualPrice + ', ' : ''}or 4 installments of ${toLocalCurrency(installment, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              })} by`}
              &nbsp;
            </p>
          ) : (
            <p className="afterpay__p body-small">available on orders $10 - $2,000 by&nbsp;</p>
          )}
          {modalToggle}
        </>
      ) : null}
    </div>
  );
};
AfterPay = observer(AfterPay);

export default AfterPay;
